module.exports = __webpack_public_path__ + "img/tu3.a11719a6.jpg";